import React, { useState, useEffect } from 'react';
import { Dialog, Grow, Icon, IconButton, makeStyles } from '@material-ui/core';
import RequestPhoneCode from './components/RequestPhoneCode';
import useRecoverPasswordModal from './useRecoverPasswordModal';
import CodeVerification from './components/CodeVerification';
import ResetPassword from './components/ResetPassword';
import Congratulations from './components/Congratulations';

const RecoverPasswordModal = (props) => {

    const classes = useStyles()
    const {open, onClose} = props
    const {system, form, actions, view_data} = useRecoverPasswordModal({open})

    let contentView = null
    console.log(view_data.step)
    if(view_data.step === 1) contentView = <RequestPhoneCode system={system} form={form} actions={actions}/>
    if(view_data.step === 2) contentView = <CodeVerification system={system} form={form} actions={actions}/>
    if(view_data.step === 3) contentView = <ResetPassword system={system} form={form} actions={actions}/>
    if(view_data.step === 4) contentView = <Congratulations system={system} form={form} actions={actions} onClose={onClose}/>
    return ( 
        <Dialog open={open} maxWidth='sm' fullWidth classes={{ paper: classes.paper }} className={classes.root}
        TransitionComponent={Transition} onClose={onClose} scroll='body'>
            <div className={classes.root}>
                <IconButton className={classes.close_button} onClick={onClose} ><Icon>close</Icon></IconButton>
                <div>
                    {contentView}
                </div>
            </div>
        </Dialog>
     );
}

const useStyles = makeStyles(theme => ({
    paper:{
        borderRadius:32, 
        padding:theme.spacing(5),
        position:'relative',
        [theme.breakpoints.down('sm')]:{
            padding:theme.spacing(3),
            margin:8
        },
        
    },
    root:{
    },
    icon:{
        //color:'white',
        borderRadius:'50%',
        fontSize:54,
        padding:8
    },
    close_button:{
        position:'absolute', right:16, top:16
    }
}))
 
export default RecoverPasswordModal;

const Transition = React.forwardRef(function Transition(props, ref) {return <Grow ref={ref} {...props} timeout={500} />;});
